const Components = require.context('./javascripts/components/')
const pages = require.context('./javascripts/pages', true, /\.js$/)

pages.keys().forEach((page) => pages(page))
